import {
  PermissionsGroupName,
  userCanAssignSalesOrderRelatedPermission,
} from '@zspace/roles';
import { User } from '@zspace/types';
import { useCallback } from 'react';
import useUser from './user';

export function useIsUserEditable() {
  const { user: currentUser } = useUser();

  const isOwnUser = useCallback(
    (user: User) => user.id === currentUser.id,
    [currentUser.id]
  );
  const isEditableBySalesOrderRelatedUser = useCallback(
    (user: User): boolean => {
      const isSelf = isOwnUser(user);
      const { deletedAt: isDeleted } = user;

      const hasNoRoles = !user.roles?.length;
      if (isSelf || isDeleted || hasNoRoles) return false;

      return user.roles.some((userRoleAssignment) =>
        userRoleAssignment.permissionsGroupUserRoleAssignments.some(
          (permissionsGroupUserRoleAssignment) =>
            permissionsGroupUserRoleAssignment.salesOrder &&
            userCanAssignSalesOrderRelatedPermission(
              currentUser,
              permissionsGroupUserRoleAssignment.salesOrder?.id,
              permissionsGroupUserRoleAssignment.permissionsGroup
                .name as PermissionsGroupName
            )
        )
      );
    },
    [currentUser, isOwnUser]
  );

  return {
    isOwnUser,
    isEditableBySalesOrderRelatedUser,
  };
}

export default useIsUserEditable;
